import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizStatisticsPage } from '@/views/admin/courses/quizzes/quiz-statistics-page.tsx';

// 深层 quiz 统计页。与编辑页相同的 `quizzes_` 脱离逻辑——挂载在
// 课程详情布局的 <Outlet/> 下，URL 保留 `quizzes` 段使
// Quizzes tab 保持高亮。
export const Route = createFileRoute('/admin/courses_/$id/quizzes_/$quizId/statistics')({
  component: QuizStatisticsRoute,
});

function QuizStatisticsRoute() {
  const { id, quizId } = useParams({ from: '/admin/courses_/$id/quizzes_/$quizId/statistics' });
  return <QuizStatisticsPage courseId={id} quizId={quizId} />;
}
